import styled, { css } from 'styled-components';
import { Input, Input as AntInput, InputNumber, InputProps } from 'antd';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { MaskedInput } from 'antd-mask-input';

const getStylesBySize = (size: InputProps['size']) => {
  switch (size) {
    case 'small':
      return css`
        height: 1.5rem;
      `;
    case 'large':
      return css`
        height: 2.5rem;
      `;
    case 'middle':
      return css`
        height: 2rem;
      `;
    default:
      return css``;
  }
};

export const inputStyles = css`
  height: 3rem;
  background: ${COLORS.WHITE};
  border-radius: 0.25rem;
  ${pickThemeFontStyles('16', '24')};
  border: 1px solid ${COLORS.GREY_VERY_LIGHT};
  box-shadow: none;

  &:not(:disabled) {
    &:focus,
    &:focus-within,
    &:hover {
      border: 1px solid ${COLORS.ORANGE_PRIMARY};
    }
  }

  input {
    padding: 0.5rem 0.75rem;
  }

  .ant-input-affix-wrapper {
    padding: 0;
  }
`;

export const StyledInput = styled(AntInput)`
  ${inputStyles};
  ${({ size }) => getStylesBySize(size)};
`;

export const StyledInputNumber = styled(InputNumber)`
  ${inputStyles};
  width: 100%;
  &.ant-input-number {
    ${({ size }) => getStylesBySize(size)};
  }

  .ant-input-number-input-wrap,
  .ant-input-number-input {
    height: 100%;
  }
`;

export const StyledPasswordInput = styled(AntInput.Password)`
  ${inputStyles};
  ${({ size }) => getStylesBySize(size)};
`;

export const StyledTextArea = styled(Input.TextArea)`
  ${inputStyles}
  ${({ size }) => getStylesBySize(size)};
`;

export const StyledMaskedInput = styled(MaskedInput)`
  ${inputStyles};
`;
